const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardDinersClub(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 80,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.95,.05h-112.1c-2.18,0-3.95,1.84-3.95,4.11V75.84c0,2.27,1.77,4.11,3.95,4.11H-23.95c2.18,0,3.95-1.84,3.95-4.11V4.16C-20,1.89-21.77,.05-23.95,.05Zm-1.95,39.95c0,21.31-16.59,38.58-37.05,38.58h-73.09c-1.45,0-2.63-1.23-2.63-2.74V4.16c0-1.51,1.18-2.74,2.63-2.74H-62.96C-42.49,1.42-25.9,18.69-25.9,40h0Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -80,
    cy: 40,
    rx: 71.18,
    ry: 74.11,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "-106.05 141.24 -177.24 12.87 -53.94 -61.24 17.24 67.13 -106.05 141.24",
    style: {
      fill: "#dc4b0d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-104.76 143.57 -175.95 15.2 -52.65 -58.92 18.53 69.45 -104.76 143.57",
    style: {
      fill: "#dd4c0c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-103.47 145.89 -174.66 17.52 -51.36 -56.59 19.82 71.78 -103.47 145.89",
    style: {
      fill: "#dd4c0c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-102.18 148.22 -173.37 19.85 -50.07 -54.26 21.11 74.11 -102.18 148.22",
    style: {
      fill: "#dd4d0c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-100.89 150.55 -172.08 22.18 -48.78 -51.94 22.4 76.43 -100.89 150.55",
    style: {
      fill: "#de4e0c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-99.6 152.87 -170.79 24.5 -47.49 -49.61 23.69 78.76 -99.6 152.87",
    style: {
      fill: "#de4f0c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-98.31 155.2 -169.5 26.83 -46.2 -47.28 24.98 81.09 -98.31 155.2",
    style: {
      fill: "#df500b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-97.02 157.53 -168.21 29.16 -44.91 -44.96 26.27 83.41 -97.02 157.53",
    style: {
      fill: "#df510b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-95.73 159.85 -166.92 31.48 -43.62 -42.63 27.56 85.74 -95.73 159.85",
    style: {
      fill: "#e0520b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-94.44 162.18 -165.63 33.81 -42.33 -40.3 28.85 88.07 -94.44 162.18",
    style: {
      fill: "#e0530b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-93.15 164.51 -164.34 36.14 -41.04 -37.98 30.14 90.39 -93.15 164.51",
    style: {
      fill: "#e0540b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-91.86 166.83 -163.05 38.46 -39.75 -35.65 31.43 92.72 -91.86 166.83",
    style: {
      fill: "#e1550a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-90.57 169.16 -161.76 40.79 -38.46 -33.33 32.72 95.04 -90.57 169.16",
    style: {
      fill: "#e1560a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-89.28 171.49 -160.47 43.12 -37.17 -31 34.01 97.37 -89.28 171.49",
    style: {
      fill: "#e2570a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-87.99 173.81 -159.18 45.44 -35.88 -28.67 35.3 99.7 -87.99 173.81",
    style: {
      fill: "#e2580a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-86.7 176.14 -157.89 47.77 -34.59 -26.35 36.59 102.02 -86.7 176.14",
    style: {
      fill: "#e3590a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-85.41 178.46 -156.6 50.09 -33.3 -24.02 37.88 104.35 -85.41 178.46",
    style: {
      fill: "#e35a09"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-84.12 180.79 -155.31 52.42 -32.01 -21.69 39.17 106.68 -84.12 180.79",
    style: {
      fill: "#e35b09"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-82.83 183.12 -154.02 54.75 -30.72 -19.37 40.46 109 -82.83 183.12",
    style: {
      fill: "#e45c09"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-81.54 185.44 -152.73 57.07 -29.43 -17.04 41.75 111.33 -81.54 185.44",
    style: {
      fill: "#e45d09"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-80.25 187.77 -151.44 59.4 -28.14 -14.71 43.04 113.66 -80.25 187.77",
    style: {
      fill: "#e55e09"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-78.96 190.1 -150.15 61.73 -26.85 -12.39 44.33 115.98 -78.96 190.1",
    style: {
      fill: "#e55f08"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-77.67 192.42 -148.86 64.05 -25.56 -10.06 45.62 118.31 -77.67 192.42",
    style: {
      fill: "#e66008"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-76.38 194.75 -147.57 66.38 -24.27 -7.73 46.91 120.64 -76.38 194.75",
    style: {
      fill: "#e66108"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-75.09 197.08 -146.28 68.71 -22.98 -5.41 48.2 122.96 -75.09 197.08",
    style: {
      fill: "#e66208"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-74.54 198.06 -145.73 69.69 -22.43 -4.42 48.75 123.95 -74.54 198.06",
    style: {
      fill: "#e76308"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-74 199.05 -145.18 70.68 -21.89 -3.44 49.3 124.93 -74 199.05",
    style: {
      fill: "#e76408"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-73.45 200.03 -144.64 71.66 -21.34 -2.45 49.84 125.92 -73.45 200.03",
    style: {
      fill: "#e76508"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-72.91 201.02 -144.09 72.65 -20.79 -1.47 50.39 126.9 -72.91 201.02",
    style: {
      fill: "#e76607"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-72.36 202 -143.54 73.63 -20.25 -.48 50.94 127.89 -72.36 202",
    style: {
      fill: "#e86707"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-71.81 202.99 -143 74.62 -19.7 .51 51.48 128.88 -71.81 202.99",
    style: {
      fill: "#e86807"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-71.27 203.98 -142.45 75.61 -19.15 1.49 52.03 129.86 -71.27 203.98",
    style: {
      fill: "#e86907"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-70.72 204.96 -141.9 76.59 -18.61 2.48 52.58 130.85 -70.72 204.96",
    style: {
      fill: "#e86a07"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-70.17 205.95 -141.36 77.58 -18.06 3.46 53.12 131.83 -70.17 205.95",
    style: {
      fill: "#e96b07"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-69.63 206.93 -140.81 78.56 -17.51 4.45 53.67 132.82 -69.63 206.93",
    style: {
      fill: "#e96c07"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-69.08 207.92 -140.26 79.55 -16.97 5.43 54.22 133.8 -69.08 207.92",
    style: {
      fill: "#e96d07"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-68.53 208.9 -139.72 80.53 -16.42 6.42 54.76 134.79 -68.53 208.9",
    style: {
      fill: "#e96e06"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-67.99 209.89 -139.17 81.52 -15.88 7.4 55.31 135.77 -67.99 209.89",
    style: {
      fill: "#ea6f06"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-67.44 210.87 -138.62 82.5 -15.33 8.39 55.86 136.76 -67.44 210.87",
    style: {
      fill: "#ea7006"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-66.89 211.86 -138.08 83.49 -14.78 9.38 56.4 137.75 -66.89 211.86",
    style: {
      fill: "#ea7106"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-66.35 212.85 -137.53 84.48 -14.24 10.36 56.95 138.73 -66.35 212.85",
    style: {
      fill: "#ea7206"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-65.8 213.83 -136.98 85.46 -13.69 11.35 57.5 139.72 -65.8 213.83",
    style: {
      fill: "#eb7306"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-65.25 214.82 -136.44 86.45 -13.14 12.33 58.04 140.7 -65.25 214.82",
    style: {
      fill: "#eb7406"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-64.71 215.8 -135.89 87.43 -12.6 13.32 58.59 141.69 -64.71 215.8",
    style: {
      fill: "#eb7506"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-64.16 216.79 -135.35 88.42 -12.05 14.3 59.14 142.67 -64.16 216.79",
    style: {
      fill: "#eb7605"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-63.61 217.77 -134.8 89.4 -11.5 15.29 59.68 143.66 -63.61 217.77",
    style: {
      fill: "#ec7705"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-63.07 218.76 -134.25 90.39 -10.96 16.28 60.23 144.65 -63.07 218.76",
    style: {
      fill: "#ec7805"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-62.52 219.74 -133.71 91.38 -10.41 17.26 60.78 145.63 -62.52 219.74",
    style: {
      fill: "#ec7905"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-61.97 220.73 -133.16 92.36 -9.86 18.25 61.32 146.62 -61.97 220.73",
    style: {
      fill: "#ec7a05"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-61.43 221.72 -132.61 93.35 -9.32 19.23 61.87 147.6 -61.43 221.72",
    style: {
      fill: "#ed7b05"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-60.88 222.7 -132.07 94.33 -8.77 20.22 62.41 148.59 -60.88 222.7",
    style: {
      fill: "#ed7c05"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-60.33 223.69 -131.52 95.32 -8.22 21.2 62.96 149.57 -60.33 223.69",
    style: {
      fill: "#ed7d05"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-59.79 224.67 -130.97 96.3 -7.68 22.19 63.51 150.56 -59.79 224.67",
    style: {
      fill: "#ed7e04"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-59.24 225.66 -130.43 97.29 -7.13 23.17 64.05 151.54 -59.24 225.66",
    style: {
      fill: "#ee7f04"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-58.69 226.64 -129.88 98.27 -6.58 24.16 64.6 152.53 -58.69 226.64",
    style: {
      fill: "#ee8004"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-58.15 227.63 -129.33 99.26 -6.04 25.15 65.15 153.52 -58.15 227.63",
    style: {
      fill: "#ee8104"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-57.6 228.62 -128.79 100.25 -5.49 26.13 65.69 154.5 -57.6 228.62",
    style: {
      fill: "#ee8204"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-57.06 229.6 -128.24 101.23 -4.94 27.12 66.24 155.49 -57.06 229.6",
    style: {
      fill: "#ef8304"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-56.51 230.59 -127.69 102.22 -4.4 28.1 66.79 156.47 -56.51 230.59",
    style: {
      fill: "#ef8404"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-55.96 231.57 -127.15 103.2 -3.85 29.09 67.33 157.46 -55.96 231.57",
    style: {
      fill: "#ef8504"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-55.42 232.56 -126.6 104.19 -3.3 30.07 67.88 158.44 -55.42 232.56",
    style: {
      fill: "#ef8603"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-54.87 233.54 -126.05 105.17 -2.76 31.06 68.43 159.43 -54.87 233.54",
    style: {
      fill: "#f08703"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-54.32 234.53 -125.51 106.16 -2.21 32.05 68.97 160.41 -54.32 234.53",
    style: {
      fill: "#f08803"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-53.78 235.51 -124.96 107.15 -1.66 33.03 69.52 161.4 -53.78 235.51",
    style: {
      fill: "#f08903"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-53.23 236.5 -124.41 108.13 -1.12 34.02 70.07 162.39 -53.23 236.5",
    style: {
      fill: "#f08a03"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-52.68 237.49 -123.87 109.12 -.57 35 70.61 163.37 -52.68 237.49",
    style: {
      fill: "#f08b03"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-52.14 238.47 -123.32 110.1 -.03 35.99 71.16 164.36 -52.14 238.47",
    style: {
      fill: "#f18c03"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-51.59 239.46 -122.77 111.09 .52 36.97 71.71 165.34 -51.59 239.46",
    style: {
      fill: "#f18d03"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-51.04 240.44 -122.23 112.07 1.07 37.96 72.25 166.33 -51.04 240.44",
    style: {
      fill: "#f18e02"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-50.5 241.43 -121.68 113.06 1.61 38.94 72.8 167.31 -50.5 241.43",
    style: {
      fill: "#f18f02"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-49.95 242.41 -121.13 114.04 2.16 39.93 73.35 168.3 -49.95 242.41",
    style: {
      fill: "#f29002"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-49.4 243.4 -120.59 115.03 2.71 40.92 73.89 169.29 -49.4 243.4",
    style: {
      fill: "#f29102"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-48.86 244.39 -120.04 116.02 3.25 41.9 74.44 170.27 -48.86 244.39",
    style: {
      fill: "#f29202"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-48.31 245.37 -119.5 117 3.8 42.89 74.99 171.26 -48.31 245.37",
    style: {
      fill: "#f29302"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-47.76 246.36 -118.95 117.99 4.35 43.87 75.53 172.24 -47.76 246.36",
    style: {
      fill: "#f39402"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-47.22 247.34 -118.4 118.97 4.89 44.86 76.08 173.23 -47.22 247.34",
    style: {
      fill: "#f39502"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-46.67 248.33 -117.86 119.96 5.44 45.84 76.63 174.21 -46.67 248.33",
    style: {
      fill: "#f39601"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-46.12 249.31 -117.31 120.94 5.99 46.83 77.17 175.2 -46.12 249.31",
    style: {
      fill: "#f39701"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-45.58 250.3 -116.76 121.93 6.53 47.82 77.72 176.18 -45.58 250.3",
    style: {
      fill: "#f49801"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-45.03 251.28 -116.22 122.91 7.08 48.8 78.26 177.17 -45.03 251.28",
    style: {
      fill: "#f49801"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-44.48 252.27 -115.67 123.9 7.63 49.79 78.81 178.16 -44.48 252.27",
    style: {
      fill: "#f49901"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-43.94 253.26 -115.12 124.89 8.17 50.77 79.36 179.14 -43.94 253.26",
    style: {
      fill: "#f49a01"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-43.39 254.24 -114.58 125.87 8.72 51.76 79.9 180.13 -43.39 254.24",
    style: {
      fill: "#f59b01"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-42.84 255.23 -114.03 126.86 9.27 52.74 80.45 181.11 -42.84 255.23",
    style: {
      fill: "#f59c01"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-42.3 256.21 -113.48 127.84 9.81 53.73 81 182.1 -42.3 256.21",
    style: {
      fill: "#f59d00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-41.75 257.2 -112.94 128.83 10.36 54.71 81.54 183.08 -41.75 257.2",
    style: {
      fill: "#f59e00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-41.21 258.18 -112.39 129.81 10.91 55.7 82.09 184.07 -41.21 258.18",
    style: {
      fill: "#f69f00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-40.66 259.17 -111.84 130.8 11.45 56.69 82.64 185.06 -40.66 259.17",
    style: {
      fill: "#f6a000"
    }
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.55,
    width: 119,
    height: 78.9,
    rx: 4,
    ry: 4,
    style: {
      fill: "#fff",
      stroke: "#0064a6",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2437",
    d: "M59.87,40h.09c.1,0,.15-.08,.15-.2s-.08-.17-.16-.17h-.09v.37h0Zm-.27,.42v-.04c.1-.01,.12,0,.12-.07v-.59c0-.08-.01-.11-.12-.11v-.04h.41c.14,0,.27,.07,.27,.21,0,.12-.08,.21-.19,.24l.13,.18c.06,.08,.13,.16,.18,.19v.03h-.15c-.08,0-.14-.16-.29-.37h-.09v.26c0,.05,.02,.05,.12,.06v.04h-.39Zm.4,.23c.36,0,.64-.3,.64-.65s-.27-.65-.64-.65-.64,.31-.64,.65,.27,.65,.64,.65h0Zm0-1.45c.46,0,.8,.35,.8,.8s-.34,.8-.8,.8-.8-.35-.8-.8,.34-.8,.8-.8Z",
    style: {
      fill: "#231f20",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.6,55.85c0,1.34,.96,1.5,1.81,1.5,3.76,0,4.99-2.84,4.99-5.43,0-3.25-2.09-5.6-5.45-5.6-.72,0-1.04,.05-1.36,.07v9.47Zm-1.71-8.16c0-1.57-.82-1.46-1.6-1.48v-.45c.68,.03,1.37,.03,2.05,.03,.73,0,1.72-.03,3.01-.03,4.51,0,6.96,3.01,6.96,6.09,0,1.72-1.01,6.06-7.17,6.06-.89,0-1.71-.03-2.52-.03s-1.55,.02-2.33,.03v-.45c1.04-.11,1.55-.14,1.6-1.32v-8.44Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.79,47.27c-.45,0-.85-.42-.85-.87s.42-.84,.85-.84,.85,.37,.85,.84-.38,.87-.85,.87m-1.86,10.18h.33c.49,0,.84,0,.84-.58v-4.72c0-.76-.26-.87-.91-1.22v-.28c.82-.25,1.79-.57,1.86-.63,.12-.07,.23-.09,.31-.09s.12,.1,.12,.25v6.68c0,.58,.38,.58,.87,.58h.29v.45c-.59,0-1.2-.03-1.83-.03s-1.25,.02-1.9,.03v-.45Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.31,52.27c0-.64-.19-.82-1.01-1.15v-.33c.75-.24,1.46-.47,2.3-.84,.05,0,.1,.03,.1,.17v1.13c.99-.71,1.85-1.31,3.01-1.31,1.48,0,2,1.08,2,2.44v4.49c0,.58,.38,.58,.87,.58h.31v.45c-.61,0-1.22-.03-1.85-.03s-1.25,.02-1.88,.03v-.45h.31c.49,0,.83,0,.83-.58v-4.5c0-.99-.61-1.48-1.6-1.48-.56,0-1.44,.45-2.02,.84v5.15c0,.58,.38,.58,.87,.58h.31v.45c-.61,0-1.22-.03-1.85-.03s-1.25,.02-1.88,.03v-.45h.31c.49,0,.83,0,.83-.58v-4.61Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3,52.54c.43,0,.48-.23,.48-.44,0-.89-.54-1.6-1.51-1.6-1.06,0-1.79,.78-2,2.04h3.03Zm-3.08,.56c-.04,.16-.04,.42,0,1.01,.1,1.65,1.17,3.01,2.56,3.01,.96,0,1.71-.52,2.35-1.16l.24,.24c-.8,1.06-1.79,1.97-3.22,1.97-2.77,0-3.32-2.68-3.32-3.79,0-3.41,2.3-4.42,3.51-4.42,1.41,0,2.93,.89,2.94,2.73,0,.11,0,.21-.02,.31l-.16,.11h-4.89Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.68,57.45h.47c.49,0,.83,0,.83-.58v-4.89c0-.54-.64-.64-.9-.78v-.26c1.27-.54,1.97-.99,2.13-.99,.1,0,.15,.05,.15,.23v1.57h.04c.43-.68,1.17-1.79,2.23-1.79,.43,0,.99,.3,.99,.92,0,.47-.33,.89-.82,.89-.54,0-.54-.42-1.15-.42-.3,0-1.27,.4-1.27,1.45v4.09c0,.58,.35,.58,.84,.58h.97v.45c-.96-.02-1.69-.03-2.43-.03s-1.45,.02-2.07,.03v-.45Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.38,55.48c.23,1.15,.92,2.12,2.19,2.12,1.03,0,1.41-.63,1.41-1.24,0-2.05-3.79-1.39-3.79-4.19,0-.98,.78-2.23,2.7-2.23,.56,0,1.3,.16,1.98,.51l.12,1.77h-.4c-.17-1.1-.78-1.72-1.9-1.72-.7,0-1.36,.4-1.36,1.15,0,2.04,4.04,1.41,4.04,4.14,0,1.15-.92,2.37-2.99,2.37-.7,0-1.51-.24-2.12-.59l-.19-2,.31-.09Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.09,48.91h-.43c-.33-2.03-1.78-2.85-3.72-2.85s-4.91,1.34-4.91,5.52c0,3.52,2.51,6.04,5.19,6.04,1.72,0,3.15-1.18,3.5-3.01l.4,.1-.4,2.54c-.73,.45-2.7,.92-3.85,.92-4.07,0-6.65-2.63-6.65-6.54,0-3.57,3.18-6.13,6.6-6.13,1.41,0,2.77,.45,4.11,.92l.17,2.49Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.72,57.45h.33c.49,0,.84,0,.84-.58v-9.69c0-1.13-.26-1.17-.92-1.36v-.28c.7-.23,1.43-.54,1.79-.75,.19-.1,.33-.19,.38-.19,.11,0,.14,.11,.14,.25v12.02c0,.58,.38,.58,.87,.58h.29v.45c-.59,0-1.2-.03-1.83-.03s-1.25,.02-1.9,.03v-.45Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.89,56.95c0,.31,.19,.33,.49,.33,.21,0,.47-.02,.7-.02v.37c-.75,.07-2.18,.43-2.51,.54l-.09-.05v-1.41c-1.04,.85-1.84,1.46-3.08,1.46-.94,0-1.91-.61-1.91-2.07v-4.46c0-.45-.07-.89-1.04-.97v-.33c.63-.02,2.02-.12,2.24-.12,.19,0,.19,.12,.19,.5v4.49c0,.52,0,2.02,1.51,2.02,.59,0,1.37-.45,2.1-1.06v-4.68c0-.35-.83-.54-1.46-.71v-.31c1.56-.11,2.54-.24,2.71-.24,.14,0,.14,.12,.14,.31v6.42Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.35,55.94c0,.66,.63,1.78,1.79,1.78,1.86,0,2.64-1.83,2.64-3.38,0-1.88-1.43-3.44-2.78-3.44-.65,0-1.18,.42-1.65,.82v4.23Zm0-4.73c.7-.59,1.64-1.25,2.59-1.25,2.02,0,3.24,1.76,3.24,3.66,0,2.28-1.67,4.56-4.16,4.56-1.29,0-1.97-.42-2.42-.61l-.52,.4-.36-.19c.16-1.03,.24-2.04,.24-3.1v-7.48c0-1.13-.26-1.17-.92-1.36v-.28c.7-.23,1.43-.54,1.79-.75,.19-.1,.33-.19,.38-.19,.1,0,.14,.11,.14,.25v6.35Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.28,68.02h.13c.34,0,.7-.05,.7-.54v-4.96c0-.49-.36-.54-.7-.54h-.13v-.28c.37,0,.94,.04,1.4,.04s1.04-.04,1.49-.04v.28h-.13c-.34,0-.7,.05-.7,.54v4.96c0,.49,.36,.54,.7,.54h.13v.28c-.45,0-1.02-.04-1.5-.04s-1.02,.04-1.39,.04v-.28Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.12,68.27v-.2s-.09,0-.09,0c-.34,0-.74-.06-.74-.58v-4.96c0-.52,.4-.58,.74-.58h.09v-.2c-.44,0-.99,.04-1.44,.04s-.99-.04-1.36-.04v.2h.09c.34,0,.74,.06,.74,.58v4.96c0,.52-.4,.58-.74,.58h-.09v.2c.37,0,.9-.04,1.35-.04s1.01,.04,1.46,.04m.04,.08c-.46,0-1.02-.04-1.5-.04s-1.02,.04-1.39,.04h-.04v-.37h.17c.34,0,.66-.04,.66-.5v-4.96c0-.46-.32-.49-.66-.5h-.17v-.37h.04c.37,0,.94,.04,1.4,.04s1.04-.04,1.49-.04h.04v.37h-.17c-.34,0-.66,.04-.66,.5v4.96c0,.46,.32,.49,.66,.5h.17v.37h-.04Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.67,66.44l.02-.02v-3.55c0-.78-.54-.89-.82-.89h-.21v-.28c.45,0,.88,.04,1.33,.04,.39,0,.78-.04,1.16-.04v.28h-.14c-.4,0-.84,.08-.84,1.2v4.31c0,.33,0,.66,.06,.96h-.36l-4.88-5.44v3.9c0,.82,.16,1.11,.89,1.11h.16v.28c-.41,0-.81-.04-1.22-.04s-.86,.04-1.29,.04v-.28h.13c.65,0,.85-.45,.85-1.2v-3.99c0-.53-.44-.85-.86-.85h-.12v-.28c.36,0,.73,.04,1.09,.04,.28,0,.56-.04,.84-.04l4.21,4.74Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.65,66.42h0s0,0,0,0h0Zm.02,.03l.03-.03-.03,.03Zm.19,1.97h.31c-.04-.28-.05-.6-.05-.91v-4.31c0-1.14,.48-1.24,.88-1.24h.1v-.2c-.37,0-.75,.04-1.12,.04-.43,0-.86-.03-1.28-.04v.2s.17,0,.17,0c.29,0,.86,.13,.86,.93v3.58s-.03,.02-.03,.02l-.03,.03-4.21-4.76c-.28,0-.56,.04-.84,.04-.35,0-.7-.03-1.05-.04v.2s.08,0,.08,0c.44,0,.9,.34,.9,.89v3.99c0,.76-.21,1.24-.89,1.24h-.09s0,.2,0,.2c.41,0,.83-.04,1.25-.04s.79,.04,1.18,.04v-.2h-.12c-.75,0-.93-.33-.93-1.15v-4.01l4.92,5.5Zm.36,.08h-.39s-4.81-5.37-4.81-5.37v3.8c.01,.82,.14,1.06,.85,1.07h.2v.37h-.04c-.41,0-.82-.04-1.22-.04-.42,0-.86,.04-1.29,.04h-.04v-.37h.18c.63,0,.8-.41,.81-1.16v-3.99c0-.5-.42-.81-.82-.81h-.17v-.37h.04c.36,0,.73,.04,1.09,.04,.28,0,.56-.04,.88-.02l4.16,4.68v-3.48c0-.75-.51-.84-.78-.85h-.25v-.37h.04c.45,0,.88,.04,1.33,.04,.39,0,.77-.04,1.16-.04h.04v.37h-.18c-.39,.01-.79,.04-.8,1.16v4.31c0,.33,.01,.66,.06,.95v.05s-.04,0-.04,0Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.56,62.17c-.71,0-.74,.17-.88,.86h-.28c.04-.26,.08-.53,.11-.8,.04-.27,.06-.53,.06-.8h.23c.08,.28,.31,.27,.57,.27h4.88c.26,0,.49,0,.51-.29l.23,.04c-.04,.25-.08,.51-.1,.77-.02,.26-.02,.51-.02,.77l-.28,.11c-.02-.35-.07-.91-.7-.91h-1.55v5.04c0,.73,.33,.81,.79,.81h.18v.28c-.37,0-1.03-.04-1.54-.04-.57,0-1.23,.04-1.6,.04v-.28h.18c.52,0,.79-.05,.79-.79v-5.06h-1.55Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3,68.35c-.37,0-1.04-.04-1.54-.04-.57,0-1.23,.04-1.6,.04h-.04v-.37h.22c.52-.01,.73-.02,.74-.75v-5.02h-1.51v-.08h1.59v5.1c0,.76-.31,.84-.83,.84h-.14v.2c.37,0,1.01-.04,1.56-.04,.49,0,1.13,.04,1.5,.04v-.2h-.14c-.46,0-.83-.11-.83-.86v-5.08h1.59c.64,0,.72,.54,.74,.89l.2-.08c0-.25,0-.49,.02-.74,.03-.24,.06-.49,.1-.73l-.14-.02c-.04,.28-.31,.29-.55,.29h-4.93c-.22,0-.47-.01-.55-.27h-.16c0,.26-.02,.52-.06,.77-.03,.26-.07,.51-.11,.76h.2c.12-.66,.21-.87,.91-.86v.08c-.7,.01-.69,.13-.84,.83v.03h-.37v-.05c.04-.26,.09-.53,.12-.81,.04-.26,.06-.53,.06-.8v-.04h.3v.03c.07,.24,.25,.24,.49,.24h4.93c.26,0,.46,0,.47-.26v-.04s.05,0,.05,0l.27,.04v.04c-.04,.25-.08,.51-.11,.76-.02,.25-.02,.51-.02,.76v.03h-.03s-.33,.13-.33,.13v-.05c-.03-.36-.07-.87-.66-.87h-1.51v5c0,.71,.29,.76,.74,.77h.22v.37h-.04Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.29,68.02h.13c.34,0,.7-.05,.7-.54v-4.96c0-.49-.36-.54-.7-.54h-.13v-.28c.58,0,1.56,.04,2.36,.04s1.78-.04,2.42-.04c-.02,.41,0,1.03,.02,1.45l-.29,.08c-.05-.62-.16-1.11-1.15-1.11h-1.31v2.48h1.12c.57,0,.69-.32,.75-.83h.28c-.02,.37-.03,.74-.03,1.11s0,.72,.03,1.08l-.28,.06c-.06-.57-.08-.94-.74-.94h-1.13v2.21c0,.62,.55,.62,1.15,.62,1.14,0,1.64-.08,1.92-1.15l.26,.07c-.12,.5-.24,1-.32,1.51-.61,0-1.7-.04-2.55-.04s-1.98,.04-2.52,.04v-.28Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.32,68.27c.08-.48,.19-.96,.31-1.43l-.19-.05c-.28,1.06-.83,1.15-1.95,1.15-.6,0-1.19,0-1.2-.66v-2.25h1.18c.66,0,.73,.39,.78,.93l.2-.04c-.02-.35-.03-.7-.03-1.05s0-.71,.03-1.07h-.2c-.05,.49-.21,.84-.78,.83h-1.17v-2.56h1.36c.98,0,1.15,.5,1.19,1.1l.2-.06c-.02-.27-.03-.61-.03-.93,0-.16,0-.32,0-.45-.64,0-1.6,.04-2.38,.04s-1.74-.03-2.32-.04v.2h.09c.34,0,.74,.06,.74,.58v4.96c0,.52-.41,.58-.74,.58h-.09v.2c.55,0,1.65-.04,2.48-.04s1.9,.04,2.51,.04m.04,.08c-.61,0-1.7-.04-2.55-.04s-1.98,.04-2.52,.04h-.04v-.37h.17c.34,0,.65-.04,.66-.5v-4.96c0-.46-.32-.49-.66-.5h-.17v-.37h.04c.58,0,1.56,.04,2.36,.04s1.78-.04,2.42-.04h.04v.04c0,.14-.01,.31-.01,.49,0,.33,0,.69,.03,.96v.03s-.03,0-.03,0l-.33,.09v-.05c-.06-.61-.14-1.06-1.12-1.07h-1.28v2.4s1.09,0,1.09,0c.55,0,.64-.28,.71-.8v-.04h.37v.04c-.02,.37-.03,.74-.03,1.11s.01,.72,.03,1.08v.03s-.03,0-.03,0l-.33,.07v-.04c-.07-.58-.07-.9-.7-.9h-1.1v2.17c0,.58,.5,.57,1.11,.58,1.14,0,1.6-.06,1.88-1.12v-.04s.05,0,.05,0l.3,.08v.04c-.13,.5-.24,1-.33,1.5v.03h-.04Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.17,64.9h.46c.95,0,1.46-.36,1.46-1.48,0-.84-.54-1.38-1.38-1.38-.28,0-.41,.03-.54,.04v2.82Zm-1.21-2.2c0-.69-.38-.72-.67-.72h-.17v-.28c.3,0,.89,.04,1.47,.04s1.02-.04,1.52-.04c1.19,0,2.25,.32,2.25,1.67,0,.85-.57,1.37-1.32,1.67l1.62,2.42c.27,.4,.45,.51,.92,.57v.28c-.31,0-.62-.04-.93-.04-.29,0-.6,.04-.89,.04-.73-.96-1.36-1.98-1.97-3.07h-.62v2.03c0,.73,.34,.76,.77,.76h.17v.28c-.54,0-1.09-.04-1.63-.04-.45,0-.9,.04-1.37,.04v-.28h.17c.35,0,.67-.16,.67-.51v-4.81Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.63,64.86c.94,0,1.41-.33,1.42-1.43,0-.83-.52-1.34-1.34-1.34-.26,0-.38,.02-.5,.04v2.74h.42Zm-.46,.08h-.04v-2.9h.04c.13-.01,.26-.04,.54-.04,.86,0,1.42,.56,1.42,1.42,0,1.13-.54,1.51-1.5,1.51h-.46Zm0,.26h.65v.02c.63,1.09,1.25,2.11,1.95,3.05,.29,0,.59-.04,.89-.04s.59,.03,.89,.04v-.21c-.44-.05-.65-.19-.91-.58l-1.65-2.46,.05-.02c.74-.29,1.29-.8,1.29-1.63,0-1.31-1.02-1.62-2.21-1.62-.5,0-.95,.04-1.52,.04s-1.12-.04-1.43-.04v.2h.13c.29,0,.71,.05,.71,.76v4.81c0,.38-.36,.55-.71,.55h-.13v.2c.46,0,.89-.04,1.33-.04,.53,0,1.06,.04,1.59,.04v-.2h-.13c-.43,0-.82-.05-.82-.8v-2.07h.04Zm4.41,3.15c-.32,0-.62-.04-.93-.04-.29,0-.59,.04-.92,.02-.73-.95-1.35-1.97-1.96-3.05h-.56v1.98c.01,.71,.3,.71,.73,.72h.21v.37h-.04c-.54,0-1.09-.04-1.63-.04-.45,0-.9,.04-1.37,.04h-.04v-.37h.21c.34,0,.63-.15,.63-.47v-4.81c0-.67-.34-.67-.63-.68h-.21v-.37h.04c.31,0,.89,.04,1.47,.04s1.02-.04,1.52-.04c1.19,0,2.29,.33,2.3,1.71,0,.85-.56,1.39-1.3,1.69l1.59,2.38c.26,.39,.43,.49,.89,.55h.03v.37h-.04Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.01,66.44l.02-.02v-3.55c0-.78-.54-.89-.82-.89h-.21v-.28c.45,0,.88,.04,1.33,.04,.39,0,.77-.04,1.17-.04v.28h-.14c-.4,0-.84,.08-.84,1.2v4.31c0,.33,0,.66,.06,.96h-.36l-4.88-5.44v3.9c0,.82,.16,1.11,.89,1.11h.16v.28c-.41,0-.81-.04-1.22-.04-.43,0-.86,.04-1.29,.04v-.28h.13c.65,0,.85-.45,.85-1.2v-3.99c0-.53-.44-.85-.86-.85h-.12v-.28c.36,0,.73,.04,1.09,.04,.28,0,.56-.04,.84-.04l4.21,4.74Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.99,66.42h0s0,0,0,0h0Zm.02,.03l.03-.03-.03,.03Zm.19,1.97h.31c-.04-.28-.05-.6-.05-.91v-4.31c0-1.14,.48-1.24,.89-1.24h.1v-.2c-.37,0-.75,.04-1.12,.04-.44,0-.86-.03-1.29-.04v.2h.17c.29,0,.87,.13,.87,.93v3.58s-.03,.02-.03,.02l-.03,.03-4.21-4.76c-.28,0-.56,.04-.84,.04-.35,0-.7-.03-1.05-.04v.2h.08c.45,0,.9,.34,.9,.89v3.99c0,.76-.21,1.24-.89,1.25h-.09s0,.2,0,.2c.41,0,.83-.04,1.25-.04s.79,.04,1.18,.04v-.2h-.12c-.75,0-.93-.33-.93-1.15v-4.01l4.92,5.5Zm.36,.08h-.39s-4.81-5.37-4.81-5.37v3.79c.01,.83,.14,1.06,.85,1.07h.2v.37h-.04c-.41,0-.82-.04-1.22-.04s-.86,.04-1.29,.04h-.04v-.37h.17c.63,0,.8-.41,.81-1.16v-3.99c0-.5-.41-.81-.82-.81h-.17v-.37h.04c.36,0,.73,.04,1.09,.04,.28,0,.55-.04,.87-.02l4.16,4.69v-3.48c0-.75-.51-.85-.78-.85h-.25v-.37h.04c.45,0,.88,.04,1.33,.04,.39,0,.77-.04,1.16-.04h.04v.37h-.18c-.39,0-.79,.04-.8,1.16v4.31c0,.33,0,.66,.06,.95v.05s-.04,0-.04,0Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.39,62.76h-.02l-.88,2.68h1.77l-.87-2.68Zm-1.38,4.2c-.1,.32-.21,.57-.21,.74,0,.29,.4,.33,.71,.33h.11v.28c-.38-.02-.77-.04-1.15-.04-.34,0-.68,.02-1.02,.04v-.28h.06c.37,0,.68-.22,.82-.62l1.52-4.35c.12-.35,.29-.82,.35-1.18,.3-.1,.68-.29,.86-.41,.03,0,.05-.02,.08-.02s.05,0,.07,.03c.03,.07,.06,.16,.09,.24l1.74,4.95c.11,.33,.23,.68,.35,.97,.12,.27,.31,.38,.63,.38h.06v.28c-.43-.02-.85-.04-1.31-.04s-.94,.02-1.42,.04v-.28h.1c.22,0,.59-.04,.59-.27,0-.12-.09-.38-.19-.68l-.37-1.1h-2.15l-.3,.99Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.35,62.77h.02s-.02,0-.02,0Zm-.8,2.63h1.66l-.82-2.54-.83,2.54Zm-.11,.08l.91-2.76h.05v.04h0s0,0,0,0v-.04h.03l.9,2.76h-1.89Zm1.94,2.78c.47-.02,.93-.04,1.38-.04s.85,.02,1.26,.04v-.2h-.01c-.32,0-.55-.13-.66-.4-.12-.29-.24-.64-.35-.97l-1.74-4.95c-.03-.08-.06-.16-.08-.23,0,0,0,0-.01,0h-.02s-.03,0-.05,.01c-.18,.12-.56,.3-.84,.38-.06,.36-.23,.83-.35,1.18l-1.51,4.35c-.14,.41-.48,.65-.86,.64h-.02v.2c.32-.02,.65-.04,.98-.04,.37,0,.74,.02,1.1,.04v-.2h-.06c-.31,0-.74-.04-.75-.37,0-.19,.12-.43,.21-.75h.04s-.04,0-.04,0l.31-1.01h2.21l.38,1.12c.11,.3,.19,.56,.19,.7-.01,.29-.41,.31-.63,.32h-.06v.2Zm2.68,.08c-.43-.02-.85-.04-1.3-.04s-.94,.02-1.42,.04h-.04s0-.04,0-.04v-.33h.15c.22,0,.54-.05,.55-.23,0-.11-.08-.37-.19-.67l-.36-1.07h-2.09l-.29,.96c-.1,.32-.21,.57-.21,.73,0,.23,.36,.29,.67,.29h.15v.37h-.04c-.38-.02-.77-.04-1.14-.04-.34,0-.68,.02-1.02,.04h-.04s0-.04,0-.04v-.33h.1c.35,0,.65-.2,.78-.59l1.52-4.35c.12-.35,.29-.82,.38-1.2,.3-.1,.68-.29,.86-.41,.03,0,.05-.02,.09-.02,.02,0,.07,0,.11,.05,.03,.08,.06,.16,.09,.24l1.74,4.95c.11,.33,.22,.68,.35,.96,.11,.25,.28,.35,.59,.35h.1v.37h-.04Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.48,62.17c-.71,0-.74,.17-.88,.86h-.28c.04-.26,.09-.53,.12-.8,.04-.27,.06-.53,.06-.8h.23c.07,.28,.31,.27,.57,.27h4.89c.25,0,.49,0,.51-.29l.23,.04c-.04,.25-.07,.51-.1,.77-.02,.26-.02,.51-.02,.77l-.28,.11c-.02-.35-.06-.91-.7-.91h-1.55v5.04c0,.73,.33,.81,.79,.81h.18v.28c-.37,0-1.03-.04-1.54-.04-.57,0-1.23,.04-1.6,.04v-.28h.18c.52,0,.79-.05,.79-.79v-5.06h-1.55Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.21,68.35c-.37,0-1.04-.04-1.54-.04-.57,0-1.23,.04-1.6,.04h-.04v-.37h.22c.52-.01,.73-.02,.74-.75v-5.02h-1.51v-.08h1.59v5.1c0,.76-.31,.84-.83,.84h-.14v.2c.37,0,1.01-.04,1.56-.04,.49,0,1.13,.04,1.5,.04v-.2h-.14c-.46,0-.83-.11-.83-.86v-5.08h1.59c.64,0,.72,.54,.74,.89l.21-.08c0-.25,0-.49,.02-.74,.03-.24,.06-.49,.1-.73l-.14-.02c-.04,.28-.31,.29-.55,.29h-4.94c-.22,0-.46-.01-.55-.28h-.15c0,.26-.02,.52-.06,.77-.03,.26-.07,.51-.11,.76h.2c.12-.66,.21-.88,.92-.86v.08c-.7,.01-.69,.13-.84,.83v.03h-.37v-.05c.05-.27,.09-.53,.12-.81,.04-.26,.06-.53,.06-.8v-.04h.3v.03c.07,.24,.25,.24,.49,.24h4.94c.26,0,.45,0,.47-.25v-.05s.05,0,.05,0l.27,.04v.04c-.05,.25-.08,.51-.11,.76-.02,.25-.02,.51-.02,.76v.03h-.03s-.33,.13-.33,.13v-.05c-.03-.36-.06-.87-.66-.87h-1.51v5c0,.71,.29,.76,.74,.77h.22v.37h-.04Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.25,68.02h.13c.34,0,.7-.05,.7-.54v-4.96c0-.49-.36-.54-.7-.54h-.13v-.28c.37,0,.94,.04,1.4,.04s1.04-.04,1.49-.04v.28h-.13c-.34,0-.7,.05-.7,.54v4.96c0,.49,.36,.54,.7,.54h.13v.28c-.46,0-1.02-.04-1.5-.04s-1.02,.04-1.39,.04v-.28Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1,68.27v-.2h-.09c-.34,0-.74-.06-.74-.58v-4.96c0-.52,.4-.58,.74-.58h.09v-.2c-.44,0-.99,.04-1.45,.04s-.99-.03-1.36-.04v.2h.09c.34,0,.74,.06,.74,.58v4.96c0,.52-.4,.58-.74,.58h-.09v.2c.36,0,.9-.04,1.35-.04s1.01,.04,1.45,.04m.04,.08c-.46,0-1.02-.04-1.5-.04s-1.02,.04-1.39,.04h-.04v-.37h.17c.34,0,.66-.04,.66-.5v-4.96c0-.46-.32-.49-.66-.5h-.17v-.37h.04c.37,0,.94,.04,1.4,.04s1.04-.04,1.49-.04h.04v.37h-.17c-.35,0-.66,.04-.66,.5v4.96c0,.46,.31,.49,.66,.5h.17v.37h-.04Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.06,68.03c1.84,0,2.16-1.62,2.16-3s-.75-3.06-2.32-3.06c-1.66,0-2.15,1.48-2.15,2.75,0,1.69,.78,3.32,2.31,3.32m-.14-6.48c2.02,0,3.63,1.25,3.63,3.27,0,2.18-1.56,3.63-3.58,3.63s-3.54-1.36-3.54-3.4,1.52-3.49,3.49-3.49",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.71,64.72c0-1.27,.5-2.79,2.19-2.79,1.61,0,2.36,1.71,2.36,3.1,0,1.38-.33,3.04-2.2,3.04v-.08c1.8,0,2.11-1.58,2.12-2.96,0-1.37-.74-3.02-2.28-3.02-1.62,0-2.1,1.44-2.11,2.7,0,1.69,.77,3.27,2.27,3.27v.08c-1.57,0-2.35-1.65-2.35-3.35m-1.33,.33c0-1.99,1.55-3.53,3.53-3.54v.08c-1.95,0-3.45,1.5-3.45,3.45,0,2.01,1.51,3.36,3.5,3.36,2,0,3.54-1.43,3.54-3.58,0-1.99-1.59-3.22-3.59-3.23v-.08c2.03,0,3.67,1.27,3.67,3.31,0,2.2-1.58,3.66-3.62,3.67-2.03,0-3.58-1.38-3.58-3.44",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,66.44l.02-.02v-3.55c0-.78-.54-.89-.83-.89h-.21v-.28c.44,0,.88,.04,1.32,.04,.39,0,.78-.04,1.17-.04v.28h-.14c-.4,0-.84,.08-.84,1.2v4.31c0,.33,0,.66,.06,.96h-.36l-4.88-5.44v3.9c0,.82,.16,1.11,.89,1.11h.16v.28c-.41,0-.81-.04-1.22-.04s-.86,.04-1.29,.04v-.28h.13c.65,0,.85-.45,.85-1.2v-3.99c0-.53-.43-.85-.86-.85h-.12v-.28c.36,0,.73,.04,1.09,.04,.28,0,.56-.04,.84-.04l4.21,4.74Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9,66.42h0s0,0,0,0h0Zm.02,.03l.03-.03-.03,.03Zm.19,1.97h.31c-.04-.28-.05-.6-.05-.91v-4.31c0-1.14,.48-1.24,.88-1.24h.1v-.2c-.38,0-.75,.04-1.13,.04-.43,0-.85-.03-1.28-.04v.2h.17c.29,0,.86,.13,.86,.93v3.58s-.03,.02-.03,.02l-.03,.03-4.21-4.76c-.28,0-.56,.04-.84,.04-.35,0-.7-.03-1.05-.04v.2h.08c.45,0,.9,.34,.9,.89v3.99c0,.76-.21,1.24-.89,1.24h-.09s0,.2,0,.2c.41,0,.83-.04,1.25-.04s.79,.04,1.18,.04v-.2h-.12c-.74,0-.93-.33-.93-1.15v-4.01l4.92,5.5Zm.36,.08h-.39s-4.81-5.37-4.81-5.37v3.8c.01,.82,.14,1.06,.85,1.06h.2v.37h-.04c-.41,0-.82-.04-1.22-.04s-.86,.04-1.29,.04h-.04v-.37h.17c.62,0,.8-.4,.81-1.16v-3.99c0-.5-.41-.81-.82-.81h-.16v-.37h.04c.36,0,.73,.04,1.09,.04,.28,0,.55-.04,.87-.02l4.16,4.68v-3.48c0-.75-.51-.84-.78-.85h-.25v-.37h.04c.44,0,.88,.04,1.32,.04,.39,0,.77-.04,1.17-.04h.04v.37h-.18c-.39,.01-.79,.05-.8,1.16v4.31c0,.33,0,.66,.05,.95v.05s-.04,0-.04,0Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.31,62.76h-.02l-.88,2.68h1.77l-.87-2.68Zm-1.38,4.2c-.09,.32-.21,.57-.21,.74,0,.29,.4,.33,.71,.33h.11v.28c-.38-.02-.77-.04-1.15-.04-.34,0-.68,.02-1.02,.04v-.28h.05c.37,0,.68-.22,.82-.62l1.52-4.35c.12-.35,.29-.82,.35-1.18,.3-.1,.68-.29,.86-.41,.03,0,.05-.02,.07-.02,.03,0,.05,0,.06,.03,.03,.07,.06,.16,.09,.24l1.74,4.95c.11,.33,.23,.68,.35,.97,.11,.27,.31,.38,.62,.38h.06v.28c-.43-.02-.85-.04-1.31-.04s-.94,.02-1.42,.04v-.28h.11c.22,0,.59-.04,.59-.27,0-.12-.09-.38-.19-.68l-.37-1.1h-2.15l-.3,.99Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.27,62.77h.02s-.02,0-.02,0Zm-.8,2.63h1.66l-.82-2.54-.83,2.54Zm-.11,.08l.91-2.76h.05v.04h-.01s.01,0,.01,0v-.04h.03l.9,2.76h-1.88Zm1.93,2.79c.47-.02,.93-.04,1.38-.04s.85,.02,1.27,.04v-.2h-.02c-.32,0-.54-.13-.66-.4-.12-.29-.24-.64-.35-.97l-1.74-4.95c-.03-.08-.06-.16-.08-.23,0-.01,0-.01-.01-.01h-.02s-.03,0-.05,.01c-.19,.12-.56,.31-.84,.38-.06,.36-.23,.83-.35,1.18l-1.52,4.35c-.14,.41-.48,.65-.86,.64h-.01v.2c.33-.02,.65-.04,.98-.04,.37,0,.74,.02,1.11,.04v-.2h-.06c-.31,0-.74-.04-.75-.37,0-.19,.12-.43,.21-.75h.04s-.04,0-.04,0l.31-1.01h2.21l.38,1.12c.1,.3,.19,.56,.19,.7-.01,.29-.41,.31-.63,.32h-.06v.2Zm2.68,.08c-.43-.02-.85-.04-1.3-.04s-.94,.02-1.42,.04h-.04s0-.04,0-.04v-.33h.14c.22,0,.55-.05,.55-.23,0-.11-.08-.37-.19-.67l-.36-1.07h-2.09l-.29,.96c-.1,.32-.21,.57-.21,.73,0,.23,.36,.29,.67,.29h.14v.37h-.04c-.38-.02-.77-.04-1.14-.04-.34,0-.68,.02-1.02,.04h-.04s0-.04,0-.04v-.33h.1c.35,0,.65-.2,.79-.59l1.51-4.35c.12-.35,.29-.82,.38-1.2,.3-.1,.68-.29,.86-.41,.02,0,.05-.02,.09-.02,.02,0,.07,0,.1,.06,.03,.07,.06,.16,.09,.24l1.74,4.95c.11,.33,.23,.68,.35,.96,.11,.25,.28,.35,.59,.35h.1v.37h-.04Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.36,67.38c0,.38,.26,.49,.57,.53,.39,.03,.81,.03,1.25-.02,.4-.05,.74-.27,.91-.51,.15-.21,.24-.47,.29-.68h.27c-.1,.54-.24,1.07-.35,1.61-.83,0-1.67-.04-2.5-.04s-1.67,.04-2.5,.04v-.28h.13c.34,0,.71-.05,.71-.63v-4.87c0-.49-.37-.54-.71-.54h-.13v-.28c.5,0,.99,.04,1.5,.04s.96-.04,1.44-.04v.28h-.24c-.36,0-.64,.01-.64,.51v4.89Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.27,68.27c.11-.51,.23-1.02,.34-1.53h-.2c-.06,.21-.14,.46-.29,.67-.18,.25-.53,.48-.94,.53-.25,.02-.49,.04-.73,.04-.18,0-.36,0-.53-.02-.31-.03-.61-.17-.61-.57v-4.89c0-.53,.33-.55,.69-.55h.19v-.2c-.47,0-.93,.04-1.4,.04s-.97-.04-1.45-.04v.2h.09c.34,0,.75,.06,.75,.58v4.87c0,.61-.41,.68-.75,.68h-.09v.2c.82,0,1.64-.04,2.46-.04s1.65,.04,2.46,.04m.03,.08c-.84,0-1.67-.04-2.5-.04s-1.67,.04-2.5,.04h-.04v-.37h.17c.34,0,.67-.03,.67-.59v-4.87c0-.46-.33-.49-.67-.5h-.17v-.37h.04c.5,0,1,.04,1.5,.04s.95-.04,1.44-.04h.04v.37h-.28c-.37,0-.6,0-.6,.47v4.89c0,.35,.23,.45,.53,.49,.17,.01,.34,.02,.53,.02,.23,0,.47-.01,.72-.04,.39-.05,.72-.27,.88-.49,.15-.2,.23-.46,.29-.67v-.03h.36v.05c-.12,.54-.25,1.07-.36,1.61v.03h-.04Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.38,62.43h.12c.13,0,.19-.1,.19-.25s-.09-.21-.19-.21h-.11v.47Zm-.34,.53v-.05c.12-.02,.14-.01,.14-.09v-.74c0-.1-.01-.14-.14-.13v-.05h.51c.18,0,.34,.08,.34,.27,0,.15-.1,.26-.24,.3l.16,.23c.08,.1,.16,.2,.22,.24v.03h-.19c-.09,0-.18-.2-.36-.46h-.11v.33c0,.07,.02,.06,.15,.08v.05h-.48Zm.5,.28c.45,0,.79-.38,.79-.81s-.34-.81-.79-.81-.79,.38-.79,.81,.34,.81,.79,.81m0-1.81c.57,0,1,.44,1,1s-.43,.99-1,.99-1-.43-1-.99,.43-1,1-1",
    style: {
      fill: "#1d1d1b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.39,28.27c0-8.86,7.18-16.04,16.04-16.04s16.04,7.18,16.04,16.04-7.18,16.04-16.04,16.04-16.04-7.18-16.04-16.04Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.45,44.59c-9.19,.04-16.76-7.4-16.76-16.47,0-9.91,7.56-16.76,16.76-16.76h4.31c9.08,0,17.37,6.85,17.37,16.76,0,9.06-8.29,16.47-17.37,16.47h-4.31Zm.04-31.85c-8.4,0-15.2,6.81-15.2,15.21,0,8.4,6.81,15.2,15.2,15.2,8.4,0,15.21-6.81,15.21-15.2,0-8.4-6.81-15.2-15.21-15.21Zm-3.45,24.2V18.96c-3.61,1.39-6.18,4.89-6.19,8.99,0,4.1,2.57,7.6,6.19,8.99Zm13.09-8.99c0-4.11-2.57-7.61-6.19-9v17.99c3.62-1.39,6.18-4.89,6.19-9Z",
    style: {
      fill: "#0064a6"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDinersClub);
export default __webpack_public_path__ + "static/media/card_diners-club.2da91b7ace8ed91ad71a10f16289b881.svg";
export { ForwardRef as ReactComponent };